import type { ReactNode } from 'react';

import './ProfileCard.scss';

interface IProfileCardProps {
  title?: ReactNode;
  tag?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

const ProfileCard = ({ title, tag, action, className, children }: IProfileCardProps) => {
  const rootClass = ['profile-card', className].filter(Boolean).join(' ');

  return (
    <section className={rootClass}>
      {(title || tag || action) && (
        <header className="profile-card__header">
          <div className="profile-card__title-group">
            {title && <h3 className="profile-card__title">{title}</h3>}
            {tag && <span className="profile-card__tag">{tag}</span>}
          </div>
          {action}
        </header>
      )}
      <div className="profile-card__body">{children}</div>
    </section>
  );
};

export default ProfileCard;
